import React from "react";

export const RightArrow = () => (
  <svg
    className="fill-current opacity-75 h-4 w-4"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z" />
  </svg>
);

export const Cross = () => (
  <svg
    className="fill-current h-4 w-4"
    role="button"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <title>Close</title>
    <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/Icons.js